<template>
    <a-table
    :columns="columns"
    :dataSource="data"
    :rowKey="(record, index) => index"
    :scroll="{ x: scrollX, y: scrollY }"
    :pagination="false"
    >
    </a-table>
</template>
  
  <script>
  export default {
    name: 'DataTable',
    props: {
      data: {
        type: Array,
        default: () => []
      },
      scrollY: {
        type: Number,
        default: 470
      }
    },
    data() {
      return {
        columns: [],
        scrollX: 0
      };
    },
    watch: {
        data: {
            handler(newData) {
            if (newData.length > 0) {
                this.generateColumns();
            }
            },
            deep: true,
            immediate: true,
        }
    },
    methods: {
        generateColumns() {
            if (!this.data || this.data.length === 0) return;
            const firstRow = this.data[0];
            const keys = Object.keys(firstRow);

            // 如果第一列标题为空，可能是 CSV 解析的问题，过滤掉空的键名
            this.columns = keys
                .filter(key => key && key.trim() !== '')
                .map(key => {
                return {
                    title: key,
                    dataIndex: key,
                    key: key,
                    width: 150,
                    sorter: (a, b) => {
                    if (a[key] < b[key]) return -1;
                    if (a[key] > b[key]) return 1;
                    return 0;
                    }
                };
                });
            this.scrollX = this.columns.length * 150;
            }
    }
  };
  </script>
  
  <style scoped>
  /* 自定义样式，提升表格的美观性 */
  .ant-table-thead > tr > th {
    background-color: #fafafa;
    font-weight: bold;
    text-align: center;
  }
  .ant-table-tbody > tr > td {
    text-align: center;
  }
  </style>
  